import { render, staticRenderFns } from "./GroupMainNav.vue?vue&type=template&id=80cab37e&"
import script from "./GroupMainNav.vue?vue&type=script&lang=ts&"
export * from "./GroupMainNav.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports